import { ChartTimePeriod, ISODuration } from "@ctra/api";
import moment from "moment/moment";
import * as _ from "lodash";

export const isChartTimePeriod = (
  period: ISODuration | ChartTimePeriod | [string, string]
): period is ChartTimePeriod => {
  return _.isPlainObject(period) && (period as ChartTimePeriod).startDate !== undefined;
};

export const isDateRangeTuple = (
  period: ISODuration | ChartTimePeriod | [string, string]
): period is [string, string] => {
  return Array.isArray(period);
};

/**
 * Default time units
 * @type {string[]}
 */
export const defaultBucketSizes: ISODuration[] = ["PT1H", "P1D", "P1W", "P1M", "P1Y"];

/**
 * Filter the time units to always be reasonable for the given time period
 * @param {ISODuration | ChartTimePeriod | [string, string]} period
 * @param {ISODuration[]} options
 * @param {number} threshold
 * @returns {ISODuration[]}
 */
export const clampChartUnitList = (
  period: ISODuration | ChartTimePeriod | [string, string],
  options: ISODuration[] = defaultBucketSizes,
  threshold = 100
): ISODuration[] => {
  let duration: moment.Duration;

  if (isChartTimePeriod(period)) {
    const { startDate, endDate } = period;

    duration = moment.duration(moment(endDate).diff(moment(startDate)));
  } else if (isDateRangeTuple(period)) {
    const [startDate, endDate] = period;

    duration = moment.duration(moment(endDate).diff(moment(startDate)));
  } else {
    duration = moment.duration(period);
  }

  return options.filter((option) => {
    const optionDuration = moment.duration(option);
    const dh = duration.asHours();
    const odh = optionDuration.asHours();
    const expectedDataPoints = _.round(dh / odh);

    return dh > odh && expectedDataPoints >= 3 && expectedDataPoints <= threshold;
  });
};
